import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPModeloObraItemPr'

// Contagem de pendencias de aprovacao do COP da obra (campos + anexos + observacao geral),
// quebrada por situacao. Obra sem COP volta zerada. Resposta crua (nao usa o envelope JsonReturn).
const GetPendencias = (obraID, config = {}) => APIClient.get(`${APIPci}/${resourceName}/pendencias/${obraID}`, config)

const COPModeloObraItemPrRepository = {
  GetPendencias
}

export default COPModeloObraItemPrRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/copmodeloobraitempr.js